/**
 * App — raiz da SPA PPM.PAGO
 *
 * Providers:
 *   - AuthProvider: login de desenvolvimento (JWT HS256 real do backend Go);
 *     token só em memória. Migra para Supabase SSO quando houver credenciais.
 *   - QueryClientProvider: TanStack Query para estado de servidor
 *   - AppRouter: roteamento com code-splitting
 *
 * ReactQueryDevtools (W1-109) só entra no bundle de dev — import estático,
 * mas `import.meta.env.DEV` é constante em build time, então o Vite faz
 * dead-code elimination do branch inteiro no bundle de produção.
 */

import { useEffect } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { AuthProvider } from '@/features/auth/auth-context'
import { Toaster } from '@/components/ui/toaster'
import { registrarErrosGlobais } from '@/lib/erro-visivel'
import { criarQueryClient } from '@/lib/query-client'
import { AppRouter } from '@/routes'

const queryClient = criarQueryClient()

export function App() {
  useEffect(() => registrarErrosGlobais(), [])

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
      <Toaster />
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
